




























































































































































import { Component, Mixins } from 'vue-property-decorator';
import CRUDMixins from '@/mixins/CRUDMixins';
import BodyMapMixins from '@/mixins/BodyMapMixins';
import TransitionMixins from '@/mixins/TransitionMixins';
import RiskProfileOptions from '@/components/RiskProfile/RiskProfileOptions.vue';
import { mapState, mapGetters } from 'vuex';
import { STATUSES } from '@/constants/risk_profile';

@Component({
  components: {
    RiskProfileOptions,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('RiskProfile', {
      riskProfile: 'riskProfile',
      questionGroups: 'questionGroups',
      extraQuestionGroups: 'extraQuestionGroups',
      bodyParts: 'bodyParts', // is used in BodyMapMixins
    }),
    ...mapState('Business', {
      business: 'business',
    }),
    ...mapGetters('RiskProfile', {
      enabledQuestionGroups: 'enabledQuestionGroups',
      availableQuestionGroups: 'availableQuestionGroups',
      bodyPartsRiskProfileItemsMap: 'bodyPartsRiskProfileItemsMap',
      questionGroupRiskProfileItems: 'questionGroupRiskProfileItems',
      bodyPartPreviewItems: 'bodyPartPreviewItems',
      enabledRiskProfileItems: 'enabledRiskProfileItems',
    }),
  },
})
export default class RiskProfileUpdate extends Mixins(
  CRUDMixins,
  BodyMapMixins,
  TransitionMixins
) {
  // RiskProfile State
  riskProfile!: {
    custom_job_role_name: string;
    name: string;
    description: string;
    status: string;
    items: [];
    risk_profile_items: [];
    extra_question_groups: string[];
  };
  questionGroups!: [];
  extraQuestionGroups!: string[];

  // Business State
  business!: Model;

  // Getters
  enabledRiskProfileItems!: [];
  enabledQuestionGroups!: [];
  availableQuestionGroups!: [];
  bodyPartsRiskProfileItemsMap!: [];
  questionGroupRiskProfileItems!: [];
  bodyPartPreviewItems!: [];

  // Data
  statuses = STATUSES;
  timer = -1;
  showPreview = false;
  showPreviewButton = true;
  currentStep = 0;
  questionGroupDescription =
    'Here is the list of the question groups the individual will complete which will provide the relevant information in their report.';

  // Computed
  get riskProfileVal() {
    return this.riskProfile;
  }
  set riskProfileVal(v) {
    this.$store.commit('RiskProfile/SET_RISK_PROFILE', v);
  }

  get selectedQuestionGroups() {
    const extraQuestionGroups: Model[] = this.questionGroups.filter(
      (item: Model) =>
        item.object_id && this.extraQuestionGroups.includes(item.object_id)
    );
    return extraQuestionGroups.map((item: Model) => item.id || 0) || [];
  }
  set selectedQuestionGroups(v: number[]) {
    if (v) {
      const selectedQuestionGroup =
        this.questionGroups.filter(
          (item: Model) => item.id && v.includes(item.id)
        ) || [];
      const questionGroupOids =
        selectedQuestionGroup.map((item: Model) => {
          return item.object_id || '';
        }) || [];
      this.$store.commit(
        'RiskProfile/SET_EXTRA_QUESTION_GROUPS',
        questionGroupOids
      );
    }
  }

  get steps() {
    return [
      {
        title: 'Step 1',
        subtitle:
          'Customise the Risk Profile<br>' +
          this.riskProfile.custom_job_role_name,
        description:
          "<p>We've set the common actions, work environment conditions, other requirements and PPE for your selected job role based on ANZSCO risk profiling.</p><p>You can tailor any aspect of the risk to meet your organisational needs.</p>",
        canProceed: () =>
          this.enabledRiskProfileItems &&
          this.enabledRiskProfileItems.length > 0,
      },
      {
        title: 'Step 2',
        subtitle: 'Optional Question Groups',
      },
      {
        title: 'Step 3',
        subtitle: 'Customise Your Profile Description',
        description: 'Tailor this section to meet your requirements',
        canProceed: () =>
          this.riskProfileVal.custom_job_role_name &&
          this.riskProfileVal.custom_job_role_name.length > 0,
      },
      {
        title: 'Step 4',
        subtitle: 'Review and Update',
      },
    ];
  }

  // BeforeMount
  beforeMount() {
    this.business.object_id = this.$route.params.businessOid;

    this.$store
      .dispatch(
        'RiskProfile/fetchFullStructure',
        this.$route.params.riskProfileOid
      )
      .then(() => {
        if (this.riskProfile.status === STATUSES.STATUS_PUBLISHED.key) {
          this.$router.push({
            name: 'administrator-risk-profile-read',
          });
        }
      });
  }

  // Methods
  navigate(selected, step, done) {
    this.currentStep = step;
    this.showPreviewButton = step < 3;
    if (!this.showPreviewButton) {
      this.showPreview = false;
    }
    done();
  }

  create() {
    this.update(STATUSES.STATUS_PUBLISHED.key);
  }

  update(status = STATUSES.STATUS_DRAFT.key) {
    const riskProfile = this.riskProfileVal;
    riskProfile.status = status;
    riskProfile.risk_profile_items = this.enabledRiskProfileItems;
    riskProfile.extra_question_groups = this.extraQuestionGroups;
    this.$store.dispatch('RiskProfile/update', riskProfile).then(() => {
      if (status === STATUSES.STATUS_PUBLISHED.key) {
        this.$router.push({
          name: 'administrator-risk-profile-read',
        });
      }
    });
  }

  toSnakeCase = (s) => {
    if (typeof s !== 'string') return '';
    s = s.replace(' ', '_');
    return s.toLowerCase();
  };

  // BeforeDestroy
  beforeDestroy() {
    this.$store.commit('Anzsco/CLEAR_STATE');
    this.$store.commit('RiskProfile/CLEAR_STATE');
    this.$store.commit('RiskProfileTemplate/CLEAR_STATE');
  }
}
